import React, { useState } from "react";
import "./index.scss";
import Paragraph from "../../atoms/paragraph";
import Button, { ButtonType } from "../../atoms/button";
import SectionTitle from "../../atoms/section-title";
import Section from "../../atoms/section";
import ButtonInfos from "../../atoms/button/lib/ButtonInfos";
import Modal from "../modal";
import Accordion, { AccordionType } from "../accordion";
import AccordionData from "../accordion/lib/AccordionData";


interface BoxProps {
    linkAccessDataForm: string,
}

const FrontPageBox = ({
    linkAccessDataForm
} : BoxProps) => {
    const baseClassName = 'm-frontpage-box';
    const [isHelpModalOpen, setHelpModalOpen] = useState(false);
    const accordionItems : AccordionData[] = [
        {
            id: '1',
            title: window.sv_resource.get("help_popup_login_title"),
            description: window.sv_resource.get('help_popup_login_description'),
        },
        {
            id: '2',
            title: window.sv_resource.get("help_popup_register_swissid_present_title"),
            description: window.sv_resource.get('help_popup_register_swissid_present_description').replace('{{linkAccessDataForm}}', linkAccessDataForm),
        },
        {
            id: '3',
            title: window.sv_resource.get("help_popup_register_no_swissid_present_title"),
            description: window.sv_resource.get('help_popup_register_no_swissid_present_description').replace('{{linkAccessDataForm}}', linkAccessDataForm),
        },
        {
            id: '4',
            title: window.sv_resource.get("help_popup_issue_with_swissid_title"),
            description: window.sv_resource.get('help_popup_issue_with_swissid_description').replace('{{swissIdContactLink}}', window.sv_resource.get('plf_onboarding_infobox_swissid_link')),
        },
    ];

    return (
        <div className={'row justify-content-md-center'}>
            <Section className={`${baseClassName} -login`}>
                <div className={`${baseClassName}__wrapper`}>
                    <SectionTitle frontpage headline level={1} title={window.sv_resource.get('frontpage_login_title')} />
                    <Paragraph className={`${baseClassName}__text`}>{window.sv_resource.get('frontpage_login_intro')}</Paragraph>
                    <div className={`${baseClassName}__buttons`}>
                        <Button href={window.sv_resource.get('frontpage_login_btn_left_link')} target="_self" text={window.sv_resource.get('frontpage_login_btn_left_text')} type={ButtonType.SwissID} />
                    </div>
                </div>
                <p className={`d-inline-block mb-0 mt-1`}>
                    {window.sv_resource.get("frontpage_help_text") + ' '}
                    <Button className={'d-inline'} type={ButtonType.Link} hasArrow={false} handleClick={() => setHelpModalOpen(true)} text={window.sv_resource.get('frontpage_help_btn_text')}/>
                </p>

            </Section>
            <Modal isOpen={isHelpModalOpen} setIsOpen={setHelpModalOpen} title={window.sv_resource.get('help_popup_title')}>
                <Accordion data={accordionItems} type={AccordionType.Bold} />
            </Modal>
        </div>
    );
};

FrontPageBox.defaultProps = {};

export default FrontPageBox;
